import api from '../../api/restaurant/restaurantReportApi';
import {
  CustomResponse,
  RestaurantReportOptionsMap,
  RestaurantReportRequest,
  RestaurantReportTypeDTO,
} from '../../types/restaurant/RestaurantReportTypes';

const RestaurantReportService = {
  listTypes: async () =>
    (await api.fetchCustom('/types')).data as CustomResponse<
      RestaurantReportTypeDTO[]
    >,
  getOptions: async (branchId: number) =>
    (await api.fetchCustom(`/branches/${branchId}/options`))
      .data as CustomResponse<RestaurantReportOptionsMap>,
  export: async (request: RestaurantReportRequest) => {
    const dateFrom = String(request.filters.dateFrom || 'desde');
    const dateTo = String(request.filters.dateTo || 'hasta');
    const extension = request.format.toLowerCase();
    const fallbackName =
      request.reportCode === 'RESTAURANT_WAITER_TIPS'
        ? `restaurant-waiter-tips-${dateFrom}_${dateTo}.${extension}`
        : `restaurant-report.${extension}`;

    return api.downloadFileFromBlob('/export', request, fallbackName);
  },
};

export default RestaurantReportService;
